import { render, staticRenderFns } from "./RmaEmailDialog.vue?vue&type=template&id=e0da27a4&scoped=true&"
import script from "./RmaEmailDialog.vue?vue&type=script&lang=js&"
export * from "./RmaEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./RmaEmailDialog.vue?vue&type=style&index=0&id=e0da27a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0da27a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSpacer})
